import { useTranslate } from '@prenuvo/halo';

import { useStudyGuard } from '@/shared/guard';
import { formatTimestampToDate } from '@/shared/util';

import { calculateAgeByAccess } from './header.util';
import { HeaderItem } from './header-item.component';
import { usePatientPermissionsAndDetails } from './use-header-permissions.hook';

export function StaticItems() {
  const {
    patient,
    radiologistScan: { scanDate },
  } = useStudyGuard();
  const { hasPIIAccess } = usePatientPermissionsAndDetails();
  const translate = useTranslate();

  return (
    <>
      <HeaderItem
        isApproximate
        label={translate('FCT.REPORTING.HEADER.LABELS.DOB') as string}
        value={translate(
          hasPIIAccess ? 'FCT.REPORTING.HEADER.DOB_PII_ACCESS' : 'FCT.REPORTING.HEADER.DOB',
          {
            age: calculateAgeByAccess(patient, hasPIIAccess),
            dob: hasPIIAccess ? patient?.dob : patient?.fake_dob,
          },
        )}
      />

      <HeaderItem
        label={translate('FCT.REPORTING.HEADER.LABELS.SCAN_DATE') as string}
        value={formatTimestampToDate(scanDate)}
      />
    </>
  );
}
